import React from "react";
import { Box, Button, Chip, IconButton, Typography, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
	container: {
		position: "sticky",
		top: 0,
		zIndex: 100,
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		border: `2px solid ${theme.palette.primary.main}`,
		borderRadius: theme.shape.borderRadius,
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: theme.spacing(2),
	},
	targetInfo: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(2),
	},
	actions: {
		display: "flex",
		gap: theme.spacing(1),
	},
	movementsList: {
		marginTop: theme.spacing(2),
		maxHeight: "150px",
		overflowY: "auto",
	},
	movementItem: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(1),
		marginBottom: theme.spacing(0.5),
		backgroundColor: theme.palette.background.default,
		borderRadius: theme.shape.borderRadius,
	},
	emptyState: {
		textAlign: "center",
		color: theme.palette.text.secondary,
		padding: theme.spacing(2),
	},
}));

export const BoxMovementBar = ({
	targetPallet,
	boxMovements,
	onFinish,
	onCancel,
	onRemoveMovement,
	onCreateNewPallet,
	onCancelNewPallet,
	isCreatingNewPallet,
	translate,
}) => {
	const classes = useStyles();

	return (
		<Paper className={classes.container} elevation={3}>
			<Box className={classes.header}>
				<Box className={classes.targetInfo}>
					<Typography variant="h6">{translate("tab.picking_list.box_movement.box_movement_mode")}</Typography>
					{targetPallet ? (
						<Typography variant="body1">
							<strong>{translate("tab.picking_list.box_movement.target_pallet")}:</strong> {targetPallet.sscc || targetPallet.id}
						</Typography>
					) : (
						<Button
							variant="outlined"
							color="primary"
							size="small"
							startIcon={<AddIcon />}
							onClick={onCreateNewPallet}
						>
							{translate("tab.picking_list.box_movement.buttons.create_new_pallet")}
						</Button>
					)}
				</Box>
				<Box className={classes.actions}>
					<Button
						variant="contained"
						color="primary"
						onClick={onFinish}
						disabled={Object.keys(boxMovements).length === 0 || !targetPallet}
					>
						{translate("tab.picking_list.box_movement.buttons.finish_movement")}
					</Button>
					<IconButton size="small" onClick={onCancel}>
						<CloseIcon />
					</IconButton>
				</Box>
			</Box>

			{Object.keys(boxMovements).length > 0 ? (
				<Box className={classes.movementsList}>
					<Typography variant="subtitle2" gutterBottom>
						{translate("tab.picking_list.box_movement.pending_movements")} ({Object.keys(boxMovements).length}):
					</Typography>
					{Object.entries(boxMovements).map(([palletId, movement]) => (
						<Box key={palletId} className={classes.movementItem}>
							<Typography variant="body2">
								{translate("tab.picking_list.box_movement.pallet")} #{palletId} - {movement.count_boxes} {translate("tab.picking_list.box_movement.box", { smart_count: movement.count_boxes })}
							</Typography>
							<IconButton size="small" onClick={() => onRemoveMovement(palletId)}>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Box>
					))}
				</Box>
			) : (
				<Box className={classes.emptyState}>
					<Typography variant="body2">
						{translate("tab.picking_list.box_movement.no_movements_added")}
					</Typography>
				</Box>
			)}
		</Paper>
	);
};
